import React from 'react';

type Props = {
  day: string;
  openingTime: string;
  closingTime: string;
};
const BrandWorkingHour = ({ day, openingTime, closingTime }: Props) => {
  return (
    <div className='flex gap-7 items-center mb-4 w-full flex-wrap'>
      <p className='text-sm font-medium capitalize min-w-[80px] grow'>{day}</p>
      <div className='inline-block border border-[#E6E5E5] rounded-md px-6 py-3 text-sm'>
        {openingTime}
      </div>
      <span>-</span>
      <div className='inline-block border border-[#E6E5E5] rounded-md px-6 py-3 text-sm'>
        {closingTime}
      </div>
    </div>
  );
};

export default BrandWorkingHour;
